<div class="search-wrapper">
  <input [(ngModel)]="searchTerm" type="search" placeholder="Search" />
  <div [inlineSVG]="'/assets/icons/magnifying-glass.svg'"></div>
</div>
<ng-container *ngIf="channelsSources | TitleFilterPipe: searchTerm as result">
  <ul class="items">
    <evrideo-content-control-opertation-room-channel
      *ngFor="let channel of result"
      [channel]="channel"
    ></evrideo-content-control-opertation-room-channel>
  </ul>
</ng-container>
